import React from 'react';
import fr from 'facet-rest';
import { pickWithPriority } from 'Helpers/Affordances';
import ProfileImage from './ProfileImage';

const ProfileImagePicker = ({ resource, ...rest }) => {
  return pickWithPriority(resource, [
    [fr.relationships.plannerProfileImageURL.name, <ProfileImage
      link={resource.relationship(fr.relationships.plannerProfileImageURL.name)?.link('related')}
      alt={resource.relationship(fr.relationships.plannerProfileImageURL.name)?.meta('prompt') || 'Profile Image'}
      {...rest}
    />,
    ],
    [fr.relationships.profileImage.name, <ProfileImage
      link={resource.relationship(fr.relationships.profileImage.name)?.link('related')}
      {...rest}
    />],
    [fr.relationships.default.name, null],
  ]);
};

export default ProfileImagePicker;
